// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import React from "react";
import { useNavigate } from "react-router-dom";
import BifrostLogo from "../../assets/Bifrost-logo.png";
import Error404 from "../../assets/Error404.png";
import DxCommonButton from "../../components/button";

const NotFound = () => {
  const navigate = useNavigate();
  const backToIndex = () => {
    const accessToken = window.localStorage.getItem("accessToken");
    if (accessToken) {
      navigate("/index");
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="w-full shadow-md fixed top-0">
        <img
          width="200"
          src={BifrostLogo}
          alt="logo"
          className="inline-block ml-2 mt-2"
        />
      </div>
      <div>
        <div className="text-center">
          <img src={Error404} alt="Error 404" className="block"/>
          <h1 className="text-xl">Page Not Found</h1>
          <p>Sorry, the page you are looking for does not exist.</p>
          <div onClick={backToIndex}>
            <DxCommonButton
              type="primary"
              className="mt-4"
              size="md"
              rounded
            >
              Back to Home
            </DxCommonButton>
          </div>
        </div>
      </div>
    </div>
  );
};

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default NotFound;